// file imports
import { LoadingSpinner } from '@/components';

interface StateMessageProps {
  type: 'loading' | 'error' | 'not-found';
  loadingMessage: string;
  errorMessage?: string;
  notFoundMessage: string;
}

export default function StateMessage({ type, loadingMessage, errorMessage, notFoundMessage }: StateMessageProps) {
  const getMessage = () => {
    switch (type) {
      case 'loading':
        return loadingMessage;
      case 'error':
        return errorMessage || `Error: ${loadingMessage}`;
      case 'not-found':
        return notFoundMessage;
      default:
        return loadingMessage;
    }
  };

  const getTextColor = () => {
    switch (type) {
      case 'loading':
        return 'text-gray-600 text-lg font-medium';
      case 'error':
        return 'text-red-600 text-lg';
      case 'not-found':
        return 'text-gray-500 text-lg';
      default:
        return 'text-lg';
    }
  };

  const renderContent = () => {
    if (type === 'loading') {
      return (
        <div className="flex flex-col items-center gap-4">
          <LoadingSpinner size="md" />
          <div className={getTextColor()}>{getMessage()}</div>
        </div>
      );
    }

    return <div className={getTextColor()}>{getMessage()}</div>;
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl p-8 shadow flex flex-col gap-6 w-full md:w-3/4 max-w-2xl text-center">{renderContent()}</div>
    </div>
  );
}
